import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";

const defaultCategories = ["General", "KYC", "Contract", "Other"];

function FileUploadModal({ show, onClose, onConfirm, categories = defaultCategories }) {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const defaultCategory = categories?.[0] || "General";
  const [selectedCategory, setSelectedCategory] = useState(defaultCategory);
  const [fileTitle, setFileTitle] = useState('');

  useEffect(() => {
    if (!show) {
      if (selectedFiles.length) {
        setSelectedFiles([]);
      }
      if (selectedCategory !== defaultCategory) {
        setSelectedCategory(defaultCategory);
      }
      if (fileTitle) {
        setFileTitle('');
      }
    }
  }, [show, defaultCategory, selectedCategory, selectedFiles.length, fileTitle]);

  const handleFileChange = (e) => {
    setSelectedFiles(Array.from(e.target.files || []));
  };

  const handleUpload = () => {
    if (!selectedFiles.length) return;
    onConfirm({ category: selectedCategory, files: selectedFiles, title: fileTitle });
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose} backdrop="static" centered>
      <ModalHeader closeButton>
        <ModalTitle>Upload Files</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <div className="mb-3">
          <label className="form-label">File Title</label>
          <input
            type="text"
            className="form-control"
            value={fileTitle}
            onChange={(e) => setFileTitle(e.target.value)}
            placeholder="Enter file title"
          />
        </div>
        <div className="mb-3">
          <label className="form-label">File Category</label>
          <select
            className="form-select"
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
          >
            {categories.map((cat) => (
              <option key={cat} value={cat}>{cat}</option>
            ))}
          </select>
        </div>
        <div className="mb-3">
          <label className="form-label">Select Files</label>
          <input
            type="file"
            className="form-control"
            multiple
            onChange={handleFileChange}
          />
          <small className="text-muted">You can select multiple files.</small>
        </div>
        {selectedFiles.length > 0 && (
          <div className="small text-muted">{selectedFiles.length} file(s) selected</div>
        )}
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
        <button className="btn btn-primary" onClick={handleUpload} disabled={!selectedFiles.length}>Upload</button>
      </ModalFooter>
    </Modal>
  );
}

export default FileUploadModal;
